<template>
  <div class="white_box tailwind">
    <div
      class="sitemap_col_headings"
      :class="{'tw-w-full tw-justify-between': isOnboarding}"
    >
      <div
        class="page_heading"
        :class="{'!tw-w-[55%] !tw-mr-10': isOnboarding}"
      >
        Page
        <custom-search
          class="sitemap_search"
          placeholder="search for url"
          @search="value => setSearchTerm(value)"
        />
      </div>

      <div
        v-if="!isOnboarding && !isSubscribedToKit"
        class="review_heading"
        :class="{'tw-w-1/4 tw-mr-1.5': isOnboarding}"
      >
        Review
      </div>

      <div class="tw-flex assigned_heading tw-justify-between tw-items-center">
        Assigned Keywords
      </div>

      <DefaultButton
        v-if="isOnboarding"
        @click="toggleEditing"
      >
        <span class="tw-flex tw-gap-1 tw-justify-center tw-items-center">
          <template v-if="!isEditing">
            <svg-vue
              icon="icons/edit_pencil"
              class="tw-h-5 tw-w-5 pencil-icon"
            />
            Edit
          </template>

          <template v-else>
            <svg-vue
              icon="icons/cross"
              class="tw-h-5 tw-w-5 pencil-icon"
            />
            Cancel
          </template>
        </span>
      </DefaultButton>
    </div>
    <div
      v-if="sitemap"
      class="sitemap_pages"
    >
      <sitemap-row
        v-for="(page, index) in filteredSitemapPages"
        :key="index"
        :page-index="index"
        :page="page"
        :page-count="sitemap.length"
        :disable-reorder="searchTerm !== ''"
        :is-onboarding="isOnboarding"
      />

      <div
        v-if="!isOnboarding"
        class="add_page"
        @click="openAddPageModal"
      >
        <svg-vue icon="icons/plus" />
        Add Page
      </div>
    </div>
  </div>

  <add-keyword v-if="showAddKeywordModal" />
  <add-page v-if="showAddPageModal" />
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CustomSearch from "../../../../views/reports/components/global/forms/CustomSearch";
import SitemapRow from "../items/SitemapRow";
import AddKeyword from "../modals/AddKeyword";
import AddPage from "../modals/AddPage";
import DefaultButton from "@/components/global/buttons/DefaultButton.vue";
import useKit from "@/composables/useKit";

export default {
  components: {
    DefaultButton,
    AddPage,
    AddKeyword,
    CustomSearch,
    SitemapRow,
  },
  props: {
    isOnboarding: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
  setup() {
    const { isSubscribedToKit } = useKit();
    return { isSubscribedToKit };
  },
  data() {
    return {
      searchTerm: '',
    }
  },
  computed: {
    ...mapGetters('strategy', [
      'sitemap',
      'showAddKeywordModal',
      'showAddPageModal',
      'hasPendingReviews',
      'isEditing',
    ]),
    filteredSitemapPages() {
      if (!this.searchTerm) {
        return this.sitemap;
      }
      return this.sitemap.filter((page) => {
        const lowerCaseUrl = page.url?.toLowerCase();
        const lowerCaseSearchTerm = this.searchTerm.toLowerCase();
        return lowerCaseUrl?.includes(lowerCaseSearchTerm);
      });
    }
  },
  watch: {
    isSubscribedToKit: {
      handler: function(newValue) {
        this.setIsSubscribedToKit(newValue);
      },
    }
  },
  async mounted() {
    await this.setIsOnboarding(this.isOnboarding);
    await this.fetchStrategy();

    if (this.hasPendingReviews) {
        await this.pollPageKeywordsReviews();
    }
  },
  methods: {
    ...mapActions('strategy', [
      'fetchStrategy',
      'openAddPageModal',
      'pollPageKeywordsReviews',
      'setIsOnboarding',
      'toggleEditing',
      'setIsSubscribedToKit',
    ]),
    setSearchTerm(value) {
      this.searchTerm = value;
    },
  }
}
</script>

<style lang="scss" scoped>
.pencil-icon :deep(path) {
  stroke: white;
}

.white_box {
  margin-bottom: 100px;

  .sitemap_col_headings {
    display: flex;
    align-items: center;
    padding: 0 0 16px 0;

    .page_heading {
      width: 40%;
      display: flex;
      align-items: center;

      .sitemap_search {
        margin-left: 15px;

        :deep(input) {
          width: 400px;
        }
      }
    }

    .review_heading {
      width: 20%;
      text-align: center;
    }

    .assigned_heading {
      flex: 1;
    }

    .page_heading, .assigned_heading, .review_heading {
      font-weight: 700;
      line-height: 1.42;
      letter-spacing: -0.042em;
      color: #040707;
      font-size: 1.5rem;
      margin: 0;
    }
  }

  .sitemap_pages {

    .add_page {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 12px 66px;
      gap: 10px;
      width: 100%;
      border-radius: 12px;
      cursor: pointer;

      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 23px;
      text-align: center;
      letter-spacing: -0.5px;
      text-transform: capitalize;
      color: #FFFFFF;

      background-color: var(--secondary-color);
      border-color: var(--secondary-color);
      transition: background-color .3s;

      &:hover {
        background-color: var(--secondary-color-dark);
        border-color: var(--secondary-color-dark);
      }
      svg {
        height: 18px;
        width: 18px;
      }
    }
  }
}
</style>
